// İstemci girişi (Next.js instrumentation-client: uygulama etkileşimli olmadan, hidrasyondan önce bir kez çalışır).
// Trusted Types "default" ilkesi: kök düzenin satır içi betiği çalışmadıysa (hata/404 kabuğu) burada kurulur.
// Ayrıntı: src/lib/security/trusted-types.ts, docs/security-headers.md
import { GA_SCRIPT_ORIGIN } from "@/lib/security/headers";
import { installTrustedTypesPolicy } from "@/lib/security/trusted-types";

installTrustedTypesPolicy(window, [GA_SCRIPT_ORIGIN]);
